import React, { useState } from "react";
import api from "../../api";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import { setAuthorized } from "../../store/userSelector";
import { Alert, Button, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./login.scss";
import Head from "../../elements/head/head";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";

const Box_Card = styled(Card)(({ theme }) => ({
  backgroundColor: theme.color.main,
  margin: "auto",
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
  color: theme.color.secondary,
  width: "200px",
}));

const But = styled(Button)(({ theme }) => ({
  backgroundColor: theme.color.banner,
  padding: theme.spacing(1),
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
  color: theme.color.secondary,
}));

const Item = styled(Box)(({ theme }) => ({
  backgroundColor: theme.color.main,
  padding: theme.spacing(1),
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
  color: theme.color.secondary,
}));

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [alert, setAlert] = useState(false);
  const isAuthorized = useSelector((state) => state.userSelector.authorized);
  const loginFunc = () => {
    setDisabled(true);
    if (username && password) {
      setAlert(null);
      api
        .loginUser(username, password)
        .then((response) => {
          dispatch(setAuthorized(response.data.token));
          console.log("токен");
          console.log(response.data.token);
          console.log(isAuthorized);
          navigate("/lk");
        })

        .catch((error) => {
          setAlert({ text: error.response.data.message, status: "error" });
        });
    } else {
      setAlert({ status: "warning", text: "Пожалуйста заполните все поля." });
    }
    setDisabled(false);
  };

  return (
    <div className="main_">
      <Grid container spacing={2}>
        <Grid size={12}>
          <Head />
        </Grid>
        <Grid size={12}>
          <Box_Card>
            <Item>
              <p>Авторизация</p>
            </Item>
            <Item>
              {" "}
              <TextField
                disabled={disabled}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                label="Логин"
                variant="outlined"
              />
            </Item>

            <Item>
              <TextField
                disabled={disabled}
                value={password}
                type="password"
                onChange={(e) => setPassword(e.target.value)}
                label="Пароль"
                variant="outlined"
              />
            </Item>

            <Item>
              <But onClick={loginFunc} disabled={disabled} variant="outlined">
                Войти
              </But>
              <But
                onClick={() => navigate("/registeruser")}
                disabled={disabled}
                variant="outlined"
              >
                Зарегистрироваться
              </But>
            </Item>
            {alert && (
              <Alert variant="outlined" severity={alert.status}>
                {alert.text}
              </Alert>
            )}
          </Box_Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default Login;
